import axios from "../../http_v2";
export default {
  tree: params => {
    return axios.get("activityservice/collaboration/tree", params);
  },
  list: params => {
    return axios.get("activityservice/collaboration/listAll", params);
  },
  save: params => {
    return axios.post("activityservice/collaboration/saveAll", params);
  },
  del: params => {
    return axios.post("activityservice/collaboration/delete", params);
  },
  report: params => {
    return axios.get("activityservice/statistics/collstat/get", params)
  }
};
